import Box from '@mui/material/Box';
import {alpha, styled} from '@mui/material/styles';

// ----------------------------------------------------------------------

export const StyledEditor = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'error',
})<{error?: boolean}>(({theme, error}) => ({
  overflow: 'hidden',
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  border: `solid 1px ${
    error ? theme.palette.error.main : alpha(theme.palette.grey[500], 0.2)
  }`,
  direction: 'ltr',
  '& .tiptap-editor-content': {
    direction: 'ltr',
  },
  '& .tiptap': {
    minHeight: 160,
    maxHeight: 640,
    overflowY: 'auto',
    padding: theme.spacing(1.5, 2),
    direction: 'ltr',
    textAlign: 'left',
    outline: 'none',
    backgroundColor: alpha(theme.palette.grey[500], 0.08),
    '&.ProseMirror-focused': {
      outline: 'none',
    },
    '& p.is-editor-empty:first-of-type::before': {
      content: 'attr(data-placeholder)',
      float: 'left',
      height: 0,
      pointerEvents: 'none',
      color: theme.palette.text.disabled,
      fontStyle: 'normal',
    },
    '& h1': {
      ...theme.typography.h1,
    },
    '& h2': {
      ...theme.typography.h2,
    },
    '& h3': {
      ...theme.typography.h3,
    },
    '& h4': {
      ...theme.typography.h4,
    },
    '& h5': {
      ...theme.typography.h5,
    },
    '& h6': {
      ...theme.typography.h6,
    },
    '& p, & li': {
      ...theme.typography.body2,
    },
    '& pre': {
      ...theme.typography.body2,
      padding: theme.spacing(2),
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.grey[900],
      color: theme.palette.common.white,
      fontFamily: 'monospace',
    },
    '& blockquote': {
      borderLeft: `3px solid ${theme.palette.divider}`,
      paddingLeft: theme.spacing(2),
      marginLeft: 0,
      color: theme.palette.text.secondary,
    },
    '& hr': {
      border: 'none',
      borderTop: `1px solid ${theme.palette.divider}`,
      margin: theme.spacing(2, 0),
    },
    '& img': {
      maxWidth: '100%',
      height: 'auto',
    },
    '& a': {
      color: theme.palette.primary.main,
      textDecoration: 'underline',
    },
  },
}));
